// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderChildren = (children, props) => {
    if (typeof children === "function") {
        return children(props);
    }
    else {
        return children;
    }
};
//# sourceMappingURL=renderChildren.js.map